import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/leads/LanguageHeader'
import LanguageTable from '../components/leads/WarehouseCreate'
import Footer from '../components/shared/Footer'

const VersionEdit = () => {
    return (
        <>
            <PageHeader>
               
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <LanguageTable />
                </div>
            </div>
            
        </>
    )
}

export default VersionEdit